
import { defineComponent } from 'vue';
import { app } from '@/store';

export default defineComponent({
  name: 'AppMain',
  computed: {
    loading() {
      return app.isLoading;
    },
  },
});
